import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PgwLabelLinkQueryCriteriaClass extends BaseCriteriaModel {
  guid?: Optional<string> = Optional.empty();
  guid_label_hdr?: Optional<string> = Optional.empty();
  header_table?: Optional<string> = Optional.empty();
  line_table?: Optional<string> = Optional.empty();
  guid_hdr?: Optional<string> = Optional.empty();
  guid_line?: Optional<string> = Optional.empty();
}

export class PgwLabelLinkCriteriaModelQuery {
  query = '';

  constructor(pgwLabelLinkCriteriaModel: PgwLabelLinkQueryCriteriaClass) {

    if (!pgwLabelLinkCriteriaModel) {
      return;
    }

    this.query += pgwLabelLinkCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += pgwLabelLinkCriteriaModel.guid_label_hdr.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');
    this.query += pgwLabelLinkCriteriaModel.header_table.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += pgwLabelLinkCriteriaModel.line_table.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += pgwLabelLinkCriteriaModel.guid_hdr.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += pgwLabelLinkCriteriaModel.guid_line.filter(x => x !== '').map(x => '&descr=' + x).orElse('');

    this.query += '&status=' + pgwLabelLinkCriteriaModel.status;
    this.query += '&orderBy=' + pgwLabelLinkCriteriaModel.orderBy;
    this.query += '&order=' + pgwLabelLinkCriteriaModel.order;
    this.query += '&offset=' + pgwLabelLinkCriteriaModel.offset + '&limit=' + pgwLabelLinkCriteriaModel.limit;
  }
}
